import { Routes } from '@angular/router';
import { authGuard } from '@core/guards/auth/auth-guard';
import { authMatchGuard } from '@core/guards/auth/auth-match-guard';
import { errorGuard } from '@core/guards/auth/error-guard';
import { loginGuard } from '@core/guards/auth/login-guard';
import { signupGuard } from '@core/guards/auth/signup-guard';
import { Home } from '@features/home/pages/home/home';
import { MainLayout } from '@layouts/main-layout/main-layout';
import { Empty } from '@shared/empty/empty';

const authRoutes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: '/' },
  { path: 'login', component: Empty, canActivate: [loginGuard] },
  { path: 'signup', component: Empty, canActivate: [signupGuard] },
  { path: 'error', component: Empty, canActivate: [errorGuard] },
  { path: 'callback', pathMatch: 'full', component: Empty },
  { path: '**', redirectTo: 'login' },
];

export const routes: Routes = [
  {
    path: 'early-access',
    loadComponent: () =>
      import('@features/early-access/early-access').then((component) => component.EarlyAccess),
  },
  { path: 'auth', children: authRoutes },
  {
    path: '',
    component: MainLayout,
    children: [
      { path: '', component: Home },
      {
        path: 'resource-invitation',
        canActivate: [authGuard],
        loadComponent: () =>
          import('@features/resource-invitation/resource-invitation').then(
            (m) => m.ResourceInvitation,
          ),
      },
      {
        path: 'documents',
        canMatch: [authMatchGuard],
        loadChildren: () =>
          import('@features/documents/documents.routes').then((m) => m.documentsRoutes),
      },
      {
        path: 'dashboard',
        canMatch: [authMatchGuard],
        loadChildren: () =>
          import('@features/dashboard/dashboard.routes').then((m) => m.dashboardRoutes),
      },
      {
        path: 'projects',
        canMatch: [authMatchGuard],
        loadChildren: () =>
          import('@features/projects/projects.routes').then((m) => m.projectsRoutes),
      },
      {
        path: 'team',
        canMatch: [authMatchGuard],
        loadChildren: () => import('@features/team/team.routes').then((m) => m.teamRoutes),
      },
      {
        path: 'pricing',
        loadChildren: () => import('@features/pricing/pricing.routes').then((m) => m.pricingRoutes),
      },
      {
        path: 'account',
        canMatch: [authMatchGuard],
        loadChildren: () => import('@features/account/account.routes').then((m) => m.accountRoutes),
      },
      { path: '**', redirectTo: '' },
    ],
  },
];
